import Devise from "@kaspernj/api-maker/build/devise"
Devise.addUserScope("user")
